import service from './request'

export function getFileList(param) {
  return service.get(`/files`, param)
}

export function deleteFiles(param) {
  return service.post(`/files/batchDelete`, param)
}

export function getAllOptions() {
  return service.get(`/options`)
}

export function getOptions(type, param = null) {
  return service.get(`/options/${type}`, param)
}

export function getImageList(param) {
  return service.get(`/images`, param)
}

export function deleteImages(param) {
  return service.post(`/images/batchDelete`, param)
}

export function compressImages(param) {
  return service.post(`/images/batchCompress`, param)
}

export function translateContent(param) {
  return service.post(`/ali/translate`, param)
}

export function getExchangeRate(param) {
  return service.get(`/exchangeRates`, param)
}

export function getBarCode(param) {
  return service.get(`/barCodes`, param)
}

export function getQrCode(param) {
  return service.get(`/qrCodes`, param)
}

export function getAllSetting() {
  return service.get(`/settings`)
}

export function getSettingByKeys(param) {
  return service.get(`/settings/keys`, param)
}

export function updateSettingByKeys(param) {
  return service.post(`/settings/keys`, param)
}